import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      sortable: true,
      fixed: true,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      sortable: true,
      fixed: true,
    },
    {
      prop: 'scientific_name',
      label: i18n.t('diseases.scientific_name'),
      sortable: true,
      fixed: true,
    },
    {
      prop: 'coefficient',
      label: i18n.t('common_words.coefficient'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'weighing_count',
      label: i18n.t('common_words.weighing_count'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'use_section',
      label: i18n.t('diseases.use_section'),
      align: 'center',
      minWidth: 100,
      formatter: (row) => {
        return [true, 1, '1'].includes(row.use_section)
          ? i18n.t('common_words.yes')
          : i18n.t('common_words.no');
      },
    },
  ];

  return { tableColumns };
};

export default configTable;
